<template>
	<apexchart 
		:width="width" 
		:height="height" 
		:options="chartOptions" 
		:series="series" 
	/>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "Abandoned",
	components: {
		apexchart: VueApexCharts,
	},
	props: {
		width: {
			type: [Number, String],
			default: "100%",
		},
		height: {
			type: [Number, String],
			default: "90%",
		},
		data: {
			type: Number,
			default: 75
		}
	},
	data() {
		return {
			zones: [
				{ min: 20.01, max: 100, color: "#f21c1c", label: "Crítico" },
				{ min: 3.01, max: 20, color: "#ee5959", label: "Atenção" },
				{ min: 0, max: 3, color: "#f0a1a1", label: "Ideal" }
			]
		};
	},
	computed: {
		currentZone() {
			return this.zones.find(zone => this.data >= zone.min && this.data <= zone.max);
		},
		barColor() {
			return this.currentZone?.color || "#6b7280";
		},
		series() {
			return [
				{
					name: "Nível de Abandono",
					data: [this.data],
				}
			];
		},
		chartOptions() {
			return {
				chart: {
					type: "bar",
					toolbar: { show: false },
				},
				title: {
					text: 'Nível de Abandono',
					align: "center",
					style: {
						fontSize: "16px",
						fontWeight: "bold",
						color: "#374151"
					},
				},
				subtitle: {
					text: `Status: ${this.currentZone?.label || 'N/A'}`,
					align: "center",
					style: {
						fontSize: "12px",
						color: this.barColor,
						fontWeight: "600"
					},
				},
				plotOptions: {
					bar: {
						horizontal: true,
						barHeight: "60%",
						distributed: true,
						borderRadius: 8,
					},
				},
				colors: [this.barColor],
				dataLabels: {
					enabled: true,
					style: {
						colors: ["#fff"],
						fontSize: "14px",
						fontWeight: "bold",
					},
					formatter: (val) => `${val}%`,
					offsetX: 10,
					dropShadow: {
						enabled: true,
						top: 1,
						left: 1,
						blur: 2,
						opacity: 0.8,
						color: "#000",
					},
				},
				xaxis: {
					show: false,
					tickAmount: 4,
					min: 0,
					max: 100,
					categories: ["Nível de Abandono"],
					axisBorder: { show: false },
					axisTicks: { show: false },
					labels: { show: false },
				},
				yaxis: {
					show: false,
				},
				grid: {
					show: false,
				},
				tooltip: {
					enabled: true,
					custom: ({ series, seriesIndex, dataPointIndex }) => {
						const value = series[seriesIndex][dataPointIndex];
						const zone = this.zones.find(z => value >= z.min && value <= z.max);
						return `
						  <div style="
						    padding: 10px; 
						    background: white; 
						    border-radius: 8px; 
						    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
						    max-width: 300px; 
						    white-space: normal; 
						    word-wrap: break-word;
						    font-size: 12px;
						    line-height: 1.4;
						  ">
						    <div style="font-weight: bold; color: ${zone?.color}; margin-bottom: 5px;">
						      ${zone?.label} (${zone?.min}-${zone?.max}%)
						    </div>
						    <div style="font-size: 11px; color: #6b7280; margin-top: 5px;">
						      ${value > 3 ? '⚠ Abandono acima do esperado' : '✓ Nível satisfatório'}
						    </div>
						    <div style="margin-top: 5px; font-size: 10px; color: #4b5563; font-weight: bold">
						      ❓ O Nível de Abandono é a porcentagem de chamadas não <br> 
							  atendidas em mais de 20 segundos sobre o total recebido
						    </div>
						  </div>
						`;
					}
				},
				legend: {
					show: false,
				},
				annotations: {
					xaxis: [
						{
							x: 3,
							strokeDashArray: 2,
							borderColor: '#f0a1a1',
							label: {
								text: '3%',
								position: 'top',
								style: {
									color: '#f0a1a1',
									background: '#FFF',
									fontSize: '11px',
									fontWeight: 600
								}
							}
						},
						{
							x: 20,
							strokeDashArray: 2,
							borderColor: '#ee5959',
							label: {
								text: '20%',
								position: 'top',
								style: {
									color: '#ee5959',
									background: '#FFF',
									fontSize: '11px',
									fontWeight: 600
								}
							}
						}
					]
				}
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.chart-container {
	padding: 0 10px;
}
</style>